import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { VrtRadioplayerFrame } from './components/VrtRadioplayerFrame';

ReactDOM.render(
  <VrtRadioplayerFrame />,
  document.getElementById('root')
);
